export default {
  orders: '/',
  details: '/detalle/:id/:restaurantId',
  recieve: '/recibir/:id',
  confirmation: '/confirmacion/:id',
  newOrder: '/nueva',
};
 